export default "__VITE_ASSET__KI4OfWPo__"